import { render, staticRenderFns } from "./ModalSelectColumnCatalog.vue?vue&type=template&id=2c027d09&scoped=true&"
import script from "./ModalSelectColumnCatalog.vue?vue&type=script&lang=js&"
export * from "./ModalSelectColumnCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectColumnCatalog.vue?vue&type=style&index=0&id=2c027d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c027d09",
  null
  
)

export default component.exports